import React from 'react';

const LandingCerrada = () => {
    return (
        <div
            style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem',
                fontFamily: "'Segoe UI', sans-serif",
            }}
        >
            {/* Logo */}
            <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
                <img
                    src="/img/logo-tortugas.png"
                    alt="Club Los Tortugas"
                    style={{ maxWidth: '160px', filter: 'drop-shadow(0 4px 16px rgba(0,140,68,0.5))' }}
                />
            </div>

            {/* Card principal */}
            <div
                style={{
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.1)',
                    borderRadius: '24px',
                    padding: '3rem 2.5rem',
                    maxWidth: '560px',
                    width: '100%',
                    textAlign: 'center',
                    backdropFilter: 'blur(12px)',
                    boxShadow: '0 24px 64px rgba(0,0,0,0.4)',
                }}
            >
                <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>🏁</div>

                <h1
                    style={{
                        color: '#ffffff',
                        fontSize: '1.8rem',
                        fontWeight: '800',
                        letterSpacing: '0.04em',
                        marginBottom: '0.5rem',
                        textTransform: 'uppercase',
                    }}
                >
                    CNA 2026
                </h1>

                <div
                    style={{
                        display: 'inline-block',
                        background: 'linear-gradient(90deg, #008C44, #00b359)',
                        color: '#fff',
                        borderRadius: '100px',
                        padding: '0.3rem 1.2rem',
                        fontSize: '0.75rem',
                        fontWeight: '700',
                        letterSpacing: '0.12em',
                        textTransform: 'uppercase',
                        marginBottom: '1.5rem',
                    }}
                >
                    Campeonato Nacional de Automovilismo
                </div>

                <div
                    style={{
                        width: '48px',
                        height: '3px',
                        background: 'linear-gradient(90deg, #008C44, #00b359)',
                        borderRadius: '4px',
                        margin: '0 auto 1.5rem',
                    }}
                />

                <h2
                    style={{
                        color: '#ffffff',
                        fontSize: '1.4rem',
                        fontWeight: '700',
                        marginBottom: '1rem',
                    }}
                >
                    Inscripciones cerradas
                </h2>

                <p
                    style={{
                        color: 'rgba(255,255,255,0.55)',
                        fontSize: '0.95rem',
                        lineHeight: '1.7',
                        margin: 0,
                    }}
                >
                    El período de inscripción para esta válida ha finalizado o aún no ha
                    sido habilitado. Mantente atento a los canales oficiales del club para
                    conocer las fechas de la próxima válida.
                </p>
            </div>

            <p style={{ color: 'rgba(255,255,255,0.15)', fontSize: '0.75rem', marginTop: '2rem', textAlign: 'center' }}>
                © {new Date().getFullYear()} Club Los Tortugas · FCAD · Coldeportes
            </p>
        </div>
    );
};

export default LandingCerrada;
